/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
import type { StreamMetadataMessage, DataSet } from '../types';

type Point = { ts: number; value: number | null };

export type SFTimeseriesWithMetadata<P extends Point = Point> = {
    data: P[];
    metadata: StreamMetadataMessage;
};

export const transformSFTimeseriesWithMetadata = (input: SFTimeseriesWithMetadata[]): DataSet =>
    inefficientButCorrectTransform(input);

/** This implementation is very inefficient, but is fully correct */
const inefficientButCorrectTransform = (input: SFTimeseriesWithMetadata[]): DataSet => {
    // 1. get all times
    const allTimes: Set<number> = input.reduce<Set<number>>((_allTimes, { data }) => {
        data.forEach(({ ts }) => {
            _allTimes.add(ts);
        });
        return _allTimes;
    }, new Set());

    // 2. make sure times are ordered and convert from millis to seconds
    const allTimesArr = Array.from(allTimes).sort((a, b) => (a > b ? 1 : -1));

    // 3. our final times should be represented in seconds, so convert them all.
    //    we keep the previous `allTimesArr` to be the "lookup" map for point values
    const allTimesInSecondsArry = allTimesArr.map(t => t / 1000);

    // 4. loop over the series and fill in nulls where time does not exist for the given series
    const dataset: DataSet = input.reduce<DataSet>(
        (_dataset, { data, metadata }) => {
            const field = metadata.properties.sf_originatingMetric;
            const seriesColumns = allTimesArr.map(ts => {
                const p = data.find(d => d.ts === ts);
                return p ? p.value : null;
            });

            _dataset.fields.push(field);
            _dataset.columns.push(seriesColumns);

            return _dataset;
        },
        {
            fields: ['_time'],
            columns: [allTimesInSecondsArry],
        }
    );

    return dataset;
};
